import React from "react";
import { Icon } from "@iconify/react";
import Button from "../../Components/Button";
import { Typography } from "../../Components/Typography";

const EditableStageFieldsPanel = ({
  title,
  subtitle,
  fields = [],
  formValues,
  onFieldChange,
  onSave,
  saving = false,
  accentClass = "bg-violet-600 hover:bg-violet-700",
  hideSaveButton = false,
}) => (
  <div className="flex flex-col gap-6">
    {(title || subtitle) && (
      <div>
        {title && (
          <Typography as="h3" className="text-lg font-bold text-slate-900">
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography as="p" className="text-sm text-slate-500 mt-1">
            {subtitle}
          </Typography>
        )}
      </div>
    )}

    <div className="flex flex-col gap-4">
      {fields.map(({ label, field, urlField, hint }) => (
        <div
          key={field}
          className="rounded-xl border border-slate-200 bg-slate-50/50 p-5 flex flex-col gap-3"
        >
          <div>
            <label className="text-sm font-semibold text-slate-800">{label}</label>
            {hint && <p className="text-xs text-slate-400 mt-0.5">{hint}</p>}
          </div>
          <textarea
            rows={4}
            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 resize-none focus:outline-none focus:ring-2 focus:ring-violet-200 focus:border-violet-400"
            placeholder={`Enter ${label.toLowerCase()}...`}
            value={formValues[field] || ""}
            onChange={(e) => onFieldChange(field, e.target.value)}
          />
          {urlField && (
            <div className="flex items-center gap-2">
              <Icon icon="lucide:paperclip" className="h-4 w-4 text-slate-400 shrink-0" />
              <input
                type="url"
                className="flex-1 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-violet-200 focus:border-violet-400"
                placeholder="Supporting link (optional)"
                value={formValues[urlField] || ""}
                onChange={(e) => onFieldChange(urlField, e.target.value)}
              />
            </div>
          )}
        </div>
      ))}
    </div>

    {!hideSaveButton && (
      <div className="flex justify-end pt-2 border-t border-slate-100">
        <Button
          variant="primary"
          size="medium"
          onClick={onSave}
          disabled={saving}
          className={accentClass}
          startIcon={
            saving ? (
              <Icon icon="lucide:loader-2" className="h-4 w-4 animate-spin" />
            ) : (
              <Icon icon="lucide:save" className="h-4 w-4" />
            )
          }
        >
          {saving ? "Saving..." : "Save changes"}
        </Button>
      </div>
    )}
  </div>
);

export default EditableStageFieldsPanel;
